export default "__VITE_ASSET__8f209b46__"